/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mArenaAssets.vue?vue&type=template&id=3babb482&scoped=true"
import script from "./mArenaAssets.vue?vue&type=script&lang=js"
export * from "./mArenaAssets.vue?vue&type=script&lang=js"
import style0 from "./mArenaAssets.vue?vue&type=style&index=0&id=3babb482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babb482",
  null
  
)

export default component.exports